module.exports = __webpack_public_path__ + "img/Price Tag.3d37617.png";